import { useEffect, useState } from "react";
import { IconDownload, IconX } from "@tabler/icons-react";
import FileUploader from "../../../components/common/FileUploader";
import toast from "react-hot-toast";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

type StaffBulkResponseModalsProps = {
  onClose: () => void;
  data: {
    successful: any[];
    failed: any[];
  };
};

export default function StaffBulkResponseModals({
  onClose,
  data,
}: StaffBulkResponseModalsProps) {
  const [file, setFile] = useState<File | null>(null);

  console.log("BulkResponsedatadatadatadatadata", data);

  const handleDownloadFailedCSV = async () => {
    if (data && data.failed && data.failed.length > 0) {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Failed Staffs");

        // Collect all unique keys except "reason"
        const allKeys = Array.from(
          new Set(data.failed.flatMap((item: any) => Object.keys(item || {}))),
        ).filter((key) => key !== "reason");

        // Add "reason" as last column
        const headings = [...allKeys, "reason"];

        // Row 1: Info
        const infoRow = worksheet.addRow([
          "This file contains failed staff import records. Please fix the red highlighted issues and re-upload.",
        ]);
        worksheet.mergeCells(
          `A1:${String.fromCharCode(65 + headings.length - 1)}1`,
        );
        infoRow.eachCell((cell: any) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "E2EFD9" }, // light yellow
          };
          cell.font = { name: "Arial", bold: true, color: { argb: "212121" } };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
        infoRow.height = 25;

        // Row 2: Validation row
        const validationRow = worksheet.addRow([
          "Full name is required",
          "Valid email is required",
          "Phone (10–12 digits) is required",
          "Warehouse is required",
          "Supervisor name",
          "Role is required",
          "Start date (YYYY-MM-DD) is required",
          "Iqama number (10 digits) is required",
          "Reason not required",
        ]);
        validationRow.eachCell((cell: any) => {
          let fillColor = "FFCCCC"; // default light red

          if (Number(cell.col) === 5 || Number(cell.col) === 9) {
            fillColor = "FFEB9C"; // light yellow
          }
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: fillColor },
          };

          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };

          cell.font = { color: { argb: "212121" } };

          cell.border = {
            top: { style: "thin", color: { argb: "FF000000" } }, // black
            left: { style: "thin", color: { argb: "FF000000" } },
            bottom: { style: "thin", color: { argb: "FF000000" } },
            right: { style: "thin", color: { argb: "FF000000" } },
          };
        });
        validationRow.height = 60; // height in points

        // Row 3: Headings
        const headingRow = worksheet.addRow(headings);
        headingRow.eachCell((cell: any) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "217447" }, // green background for failed sheet headings
          };
          cell.font = { name: "Arial", bold: true, color: { argb: "FFFFFF" } };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
        headingRow.height = 20;

        // Add failed rows
        data.failed.forEach((item: any) => {
          const rowValues = headings.map((key) => item[key] ?? "");
          const row = worksheet.addRow(rowValues);

          row.eachCell((cell: any, colNumber: number) => {
            // Highlight reason column differently
            if (headings[colNumber - 1] === "reason") {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFCCCC" }, // light red for reason
                color: { argb: "FFFFFF" },
              };
            }
            cell.alignment = {
              horizontal: "center",
              vertical: "middle",
              wrapText: true,
            };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });

        // Adjust column widths
        worksheet.columns = headings.map(() => ({ width: 25 }));

        // Export Excel
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "failed-staffs.xlsx");

        toast.success("Failed staffs Excel downloaded successfully");
      } catch (err) {
        console.error("Excel generation error:", err);
        toast.error("Failed to generate Excel file");
      }
    } else {
      toast.error("No failed data available to download");
    }
  };

  return (
    <>
      {/* <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
        <div className="rounded-2xl "> 
          <div className="flex items-center">
            <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px] ">
              <h2 className="text-xl">Upload Status Report</h2>
            </div>
            <div className="relative ">
              <button
                onClick={onClose}
                className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
              >
                <IconX size={20} />
              </button>
            </div>
          </div> 
          <div className="w-full py-4 pt-2 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tl-none rounded-[30px]">
            <div
              className={` grid  ${
                data?.successful?.length > 0 && data?.failed?.length > 0
                  ? "grid-cols-2 w-[800px] gap-4 "
                  : "grid-cols-1 w-[650px] gap-y-4 "
              } `}
            >
              {data?.successful?.length > 0 && data?.failed?.length === 0 && (
                <div className="flex flex-col items-center justify-center gap-0">
                  <svg
                    height="60"
                    viewBox="0 0 520 520"
                    width="60"
                    xmlns="http://www.w3.org/2000/svg"
                    id="fi_5290117"
                  >
                    <g id="_68-Contract" data-name="68-Contract">
                      <path
                        d="m80.144 30v406.177h179.195v-20l110.661-110.654h20v-275.523z"
                        fill="#d8d8d8"
                      ></path>
                      <g fill="#707070">
                        <path d="m144.45 118.951h181.277v20h-181.277z"></path>
                        <path d="m144.45 174.813h181.277v20h-181.277z"></path>
                        <path d="m144.45 230.675h181.277v20h-181.277z"></path>
                        <path d="m144.45 286.538h54.666v20h-54.666z"></path>
                      </g>
                      <path
                        d="m339.884 488a99.956 99.956 0 1 1 99.955-99.955 100.069 100.069 0 0 1 -99.955 99.955z"
                        fill="#b0ef8f"
                      ></path>
                      <path
                        d="m316.09 444.313-28.789-31.988 14.865-13.379 13.43 14.921 61.792-73.313 15.293 12.89z"
                        fill="#009045"
                      ></path>
                    </g>
                  </svg>

                  <p className="text-xl font-medium">
                    Data Uploaded Sucussfully{" "}
                  </p>
                  <p className="text-sm text-[#212121]/70 text-center">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Pariatur iure a consequuntur accusamus voluptatem earum
                    alias! Aliquid aperiam maxime, blanditiis doloremque rem
                    odit quisquam ab ea eius, aspernatur voluptatibus iure!
                  </p>
                </div>
              )}
              {data?.successful?.length > 0 && data?.failed?.length > 0 && (
                <div className="  gap-4 bg-green-500/10  rounded-xl border-[#D2D2D2] border max-h-[24rem] overflow-y-auto scrollbar-clean">
                  <p className="text-sm text-black font-medium p-2">
                    Succefully Data List ({data?.successful?.length})
                  </p>
                  <table className="w-full px-4">
                    <thead className="  text-[#212121]/70 border-y border-dashed border-black/10">
                      <th className="text-left font-medium p-1 px-2 text-xs">
                        #
                      </th>
                      <th className="text-left font-medium p-1 px-2 text-xs">
                        Reference Number
                      </th>
                      <th className="text-left font-medium p-1 px-2 text-xs">
                        Client ID
                      </th>
                      <th className="text-left font-medium p-1 px-2 text-xs">
                        Receiver Name
                      </th>
                    </thead>
                    <tbody className="divide-y divide-black/10  ">
                      {data?.successful?.map((item, index) => (
                        <tr key={index} className="text-xs font-[#212121]">
                          <tr key={index} className="text-xs font-[#212121]">
                            <td className="p-2">{index + 1}</td>
                            <td className="p-2">{item.fullName}</td>
                            <td className="p-2">{item.phone}</td>
                            <td className="p-2">{item.email}</td>
                          </tr>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {data?.failed?.length > 0 && (
                <div className=" gap-4 bg-red-500/10 rounded-xl border-[#D2D2D2] border w-full max-h-[24rem] overflow-y-auto scrollbar-clean ">
                  <p className="text-sm text-black font-medium  p-2">
                    Failed Data List ({data?.failed?.length})
                  </p>
                  <table className="w-full px-4 ">
                    <thead className="  text-[#212121]/70 border-y border-dashed border-black/10">
                      <th className="text-left font-medium p-1 px-2 text-xs">
                        #
                      </th>
                      <th className="text-left font-medium p-1 px-2 text-xs">
                        Name
                      </th>
                      <th className="text-left font-medium p-1 px-2 text-xs">
                        Mobile Number
                      </th>
                      <th className="text-left font-medium p-1 px-2 text-xs w-72">
                        Error
                      </th>
                    </thead>
                    <tbody className="divide-y divide-black/10 ">
                      {data?.failed.map((item, index) => (
                        <tr key={index} className="text-xs font-[#212121]">
                          <td className="p-2">{index + 1}</td>
                          <td className="p-2">{item.fullName}</td>
                          <td className="p-2">{item.phone}</td>
                          <td className="p-2 ">
                            <p className="line-clamp-1 ">{item.reason}</p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {data?.failed?.length > 0 && (
                <div className="col-span-2 flex items-center justify-between gap-4 bg-[#fff] px-4 py-2 rounded-md border-[#D2D2D2] border border-black/5 ">
                  <p className="text-xs text-[#212121] font-medium">
                    <b>Note:</b> We found {data?.failed?.length} records failed
                    to upload. Review the CSV file, correct the errors, and
                    re-upload.
                  </p>
                  <button
                    onClick={handleDownloadFailedCSV}
                    className="bg-[#212121] text-white flex items-center space-x-1 p-2 px-4 rounded-md text-sm flex-shrink-0"
                  >
                    <IconDownload size={20} />
                    <span>Failed Data</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div> */}

      <div className="relative bg-white rounded-3xl shadow-sm border flex flex-col overflow-hidden h-full">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white">
          <h2 className="text-xl font-semibold text-[#212121]">
            Upload Status Report
          </h2>

          <div className="flex items-center gap-3">
            <button
              onClick={onClose}
              className="p-2 rounded-lg border border-[#D2D2D2]"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>

        <div className="space-y-4 p-6">
          <div
            className={` grid  ${
              data?.successful?.length > 0 && data?.failed?.length > 0
                ? "grid-cols-2 w-[800px] gap-4 "
                : "grid-cols-1 w-[650px] gap-y-4 "
            } `}
          >
            {data?.successful?.length > 0 && data?.failed?.length === 0 && (
              <div className="flex flex-col items-center justify-center gap-0">
                <svg
                  height="60"
                  viewBox="0 0 520 520"
                  width="60"
                  xmlns="http://www.w3.org/2000/svg"
                  id="fi_5290117"
                >
                  <g id="_68-Contract" data-name="68-Contract">
                    <path
                      d="m80.144 30v406.177h179.195v-20l110.661-110.654h20v-275.523z"
                      fill="#d8d8d8"
                    ></path>
                    <g fill="#707070">
                      <path d="m144.45 118.951h181.277v20h-181.277z"></path>
                      <path d="m144.45 174.813h181.277v20h-181.277z"></path>
                      <path d="m144.45 230.675h181.277v20h-181.277z"></path>
                      <path d="m144.45 286.538h54.666v20h-54.666z"></path>
                    </g>
                    <path
                      d="m339.884 488a99.956 99.956 0 1 1 99.955-99.955 100.069 100.069 0 0 1 -99.955 99.955z"
                      fill="#b0ef8f"
                    ></path>
                    <path
                      d="m316.09 444.313-28.789-31.988 14.865-13.379 13.43 14.921 61.792-73.313 15.293 12.89z"
                      fill="#009045"
                    ></path>
                  </g>
                </svg>

                <p className="text-xl font-medium">
                  Data Uploaded Sucussfully{" "}
                </p>
                <p className="text-sm text-[#212121]/70 text-center">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Pariatur iure a consequuntur accusamus voluptatem earum alias!
                  Aliquid aperiam maxime, blanditiis doloremque rem odit
                  quisquam ab ea eius, aspernatur voluptatibus iure!
                </p>
              </div>
            )}
            {data?.successful?.length > 0 && data?.failed?.length > 0 && (
              <div className="  gap-4 bg-green-500/10  rounded-xl border-[#D2D2D2] border max-h-[24rem] overflow-y-auto scrollbar-clean">
                <p className="text-sm text-black font-medium p-2">
                  Succefully Data List ({data?.successful?.length})
                </p>
                <table className="w-full px-4">
                  <thead className="  text-[#212121]/70 border-y border-dashed border-black/10">
                    <th className="text-left font-medium p-1 px-2 text-xs">
                      #
                    </th>
                    <th className="text-left font-medium p-1 px-2 text-xs">
                      Reference Number
                    </th>
                    <th className="text-left font-medium p-1 px-2 text-xs">
                      Client ID
                    </th>
                    <th className="text-left font-medium p-1 px-2 text-xs">
                      Receiver Name
                    </th>
                  </thead>
                  <tbody className="divide-y divide-black/10  ">
                    {data?.successful?.map((item, index) => (
                      <tr key={index} className="text-xs font-[#212121]">
                        <tr key={index} className="text-xs font-[#212121]">
                          <td className="p-2">{index + 1}</td>
                          <td className="p-2">{item.fullName}</td>
                          <td className="p-2">{item.phone}</td>
                          <td className="p-2">{item.email}</td>
                        </tr>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {data?.failed?.length > 0 && (
              <div className=" gap-4 bg-red-500/10 rounded-xl border-[#D2D2D2] border w-full max-h-[24rem] overflow-y-auto scrollbar-clean ">
                <p className="text-sm text-black font-medium  p-2">
                  Failed Data List ({data?.failed?.length})
                </p>
                <table className="w-full px-4 ">
                  <thead className="  text-[#212121]/70 border-y border-dashed border-black/10">
                    <th className="text-left font-medium p-1 px-2 text-xs">
                      #
                    </th>
                    <th className="text-left font-medium p-1 px-2 text-xs">
                      Name
                    </th>
                    <th className="text-left font-medium p-1 px-2 text-xs">
                      Mobile Number
                    </th>
                    <th className="text-left font-medium p-1 px-2 text-xs w-72">
                      Error
                    </th>
                  </thead>
                  <tbody className="divide-y divide-black/10 ">
                    {data?.failed.map((item, index) => (
                      <tr key={index} className="text-xs font-[#212121]">
                        <td className="p-2">{index + 1}</td>
                        <td className="p-2">{item.fullName}</td>
                        <td className="p-2">{item.phone}</td>
                        <td className="p-2 ">
                          <p className="line-clamp-1 ">{item.reason}</p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {data?.failed?.length > 0 && (
              <div className="col-span-2 flex items-center justify-between gap-4 bg-[#fff] px-4 py-2 rounded-md border-[#D2D2D2] border border-black/5 ">
                <p className="text-xs text-[#212121] font-medium">
                  <b>Note:</b> We found {data?.failed?.length} records failed to
                  upload. Review the CSV file, correct the errors, and
                  re-upload.
                </p>
                <button
                  onClick={handleDownloadFailedCSV}
                  className="bg-[#212121] text-white flex items-center space-x-1 p-2 px-4 rounded-md text-sm flex-shrink-0"
                >
                  <IconDownload size={20} />
                  <span>Failed Data</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
